export const NAVIGATION_GRID_AREAS = {
    ACTIONS: 'navigation-actions',
    LEFT: 'navigation-left',
    MAIN: 'navigation-main',
    SECONDARY: 'navigation-secondary',
    TOGGLE: 'navigation-toggle',
};
